import {
  ErrorDisplayActions,
  ErrorDisplayContent,
  ErrorDisplayHeadline,
  ErrorDisplayLockup,
  ErrorDisplayLogo,
  ErrorDisplayMessage,
  ErrorDisplayRoot,
} from "~/shared/components/errors/ErrorDisplay";
import { EVENTS_PATHS } from "~/team/constants/paths.constants";
import { ButtonLink } from "./ds/ButtonLink";

export function EventNotFound({ children }: { children: React.ReactNode }) {
  return (
    <ErrorDisplayRoot>
      <ErrorDisplayLogo />
      <ErrorDisplayContent>
        <ErrorDisplayLockup>
          <ErrorDisplayHeadline>Event not found</ErrorDisplayHeadline>
          <ErrorDisplayMessage>
            This event is no longer available, or the link may be broken. Browse all upcoming events to find what you're
            looking for, or try reloading the page.
          </ErrorDisplayMessage>
        </ErrorDisplayLockup>
        <ErrorDisplayActions>{children}</ErrorDisplayActions>
      </ErrorDisplayContent>
    </ErrorDisplayRoot>
  );
}

export function TeamEventNotFound() {
  return (
    <EventNotFound>
      <ButtonLink variant="default" to={EVENTS_PATHS.root}>
        View Events
      </ButtonLink>
    </EventNotFound>
  );
}
